import api from '@/components/mixins/baseApi';

export default {
  mixins: [api],
  methods: {
    getAbout() {
      this.$store.commit('setProgressVal', 1);
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/about`,
        onDownloadProgress: (progressEvent) => {
          this.$store.commit('setProgressVal', Math.round(progressEvent.progress * 100));
        },
      })
        .then((data) => data.results)
        .catch((error) => {
          this.$store.commit('setProgressVal', 100);
          return error;
        });
    },
  },
};
